import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {TheCage} from "../TheCage";
import {gsap} from "gsap";
import {TheCageSound} from "../sound/TheCageSound";

export class TheCageBetPresentation implements FlowStatePresentation {

    constructor() {}

    public start(flowStateController:FlowStateController) {
        const tl:gsap.core.Timeline = gsap.timeline();

        tl.add(() => {
            TheCage.soundPlayer.playSound(TheCageSound.REELS_OUT);
            TheCage.reelView.multiplierDisplay.reset();
        });

        tl.add(()=>{TheCage.reelView.avalancheMatrixModel.dropOut()});
        tl.add(() => {
            flowStateController.finish()
        }, "<0.3");
    }
}